export function getErrorMessage(err: unknown, defaultMessage: string): string {
  return err instanceof Error ? err.message : defaultMessage;
}

export function isCancelledError(message: string): boolean {
  return message.includes('cancelled') || message.includes('canceled');
}
